import { tvgColorPalette as colors } from "@tvg/design-system/src/theming/themes/common/tvgColorPalette";
import styled, { css } from "styled-components";

const RaceList = styled.ol<{
  hasMoreButtonPresent: boolean;
  borderOnLastItem: boolean;
}>`
  list-style: none;
  margin: 0;
  padding: 0;
  ${(props) =>
    props.hasMoreButtonPresent
      ? css`
          & > li {
            border-bottom: 1px solid ${colors.blue[100]};
          }
        `
      : css`
          & > li:not(:first-child) {
            border-top: 1px solid ${colors.blue[100]};
          }
        `};
  ${(props) =>
    props.borderOnLastItem &&
    css`
      & > li:last-child {
        border-bottom: 1px solid ${colors.blue[100]};
      }
    `}
`;

export default RaceList;
